<template>
  <article class="max-w-screen-3xl mx-auto pl-4 pr-12">
    <form @submit.prevent="search">
      <div class="flex justify-end relative">
        <input
          type="text"
          placeholder="Buscar"
          name="query"
          :value="query"
          @input="updateQuery"
        />

        <div class="btn-close" @click="clearSearch()">
          <BaseIcon name="times" />
        </div>

        <div class="absolute right-0 top-0">
          <button class="btn-search">
            <BaseIcon name="search" />
          </button>
        </div>
      </div>
    </form>
  </article>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('videos', ['videosAction', 'query']),
  },

  mounted() {
    this.$store.commit('videos/updateQuery', '')
  },

  methods: {
    updateQuery(e) {
      this.$store.commit('videos/updateQuery', e.target.value)
    },

    search() {
      this.$store.dispatch(`videos/${this.videosAction}`, {
        slug: this.$route.params.slug,
      })
    },

    clearSearch() {
      this.$store.commit('videos/updateQuery', '')
      this.search()
    },
  },
}
</script>

<style scoped>
input {
  @apply appearance-none border-l border-t border-b border-secondary-500 px-4 py-2 rounded-l w-full max-w-sm;
}

.btn-close {
  @apply cursor-pointer text-secondary-500 px-5 py-2 border-t border-b border-secondary-500 absolute top-0;
  right: 2.5rem;
}

.btn-search {
  @apply bg-secondary-500 text-white rounded-r px-3 py-2 border border-secondary-500;
}
</style>
